<script>
  import Sidebar from '../../components/Sidebar.vue'
  import Topbar from '../../components/Topbar.vue'
  import { mapState } from 'vuex'

  export default {
      name: 'config-yzxml',
      components: {
          Sidebar,
          Topbar
      },
      created () {
        if (this.user.user.tipo !== 'A') {
          this.$router.push('/')
        }
      },
      computed: {
        ...mapState('auth', ['user'])
      },
      data () {
          return {

          }
      }
  }
</script>

<template>
  <div class="">
    <Topbar />
    <div id="wrapper">
      <Sidebar />
        <div class="card size-card mx-auto mt-5">
          <p class="card-header text-center">YzXML - Sobre</p>

          <div class="card-body">
            <form @submit.prevent="onSubmit()">
              <div class="form-group">        
              <div class="form-group">
                <label for="sobre">Sobre:</label>
                <textarea class="form-control no-resize" rows="13" id="sobre"></textarea>
              </div>
                <button type="submit" class="btn bg-blue-dt">Salvar</button>
              </div>  
            </form>
          </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
    .size-card{width: 70%}
    .no-resize{resize: none;}
</style>